import { IItem } from "../items";
import { IDocumentAlert } from "../IDocumentAlert";

export abstract class AbstractDocumentAlert implements IDocumentAlert {
  constructor(public isError: boolean) {
  }
  abstract get detectedItem(): IItem;
  abstract get kind(): string;
  abstract get target(): string;
  abstract get description(): string;
  abstract get itemSetId(): number;
  
  /** 確認ダイアログでキャンセルされたらtrueになる */
  public isConfirmDenied: boolean;
}
